module.exports = __webpack_public_path__ + "static/Logo-5b3ecbeae0cfa37f47ec70be6b7469c6.svg";